import { Player } from "../Player";
import PlayerState, { PlayerStateTypes } from "./PlayerState"

export default class PlayerStateCrash extends PlayerState {

    anim: SpineGameObject;

    constructor(player: Player, imgPrefix: string) {
        super(player, imgPrefix, PlayerStateTypes.Crash);
    }

    beginState(end = false): void {
        super.beginState();
        if (end) return;
        const dizzyOffset = this.player.character.dizzyOffset;
        const crashOffset = this.player.character.crashOffset;
        const anim = this.anim = this.scene.add.spine(-70 + dizzyOffset.x, -50 + dizzyOffset.y, "dizzy-stars", "stun", true);
        this.player.img.x += crashOffset.x;
        this.player.img.y += crashOffset.y;
		anim.scale = 0.5;
        this.player.spineContainer.add(anim);

        if (this.player.glow.alpha == 1) {
            this.scene.tweens.add({
                targets: this.player.glow,
                alpha: 0,
                scale: 0,
                duration: 300,
            });
        }
        
    }

    shutDown(): void {
        if (this.anim) this.anim.destroy();
        super.shutDown();
    }

}